import angular from 'angular';

import { workingWith } from './working.with.directive';

export default angular
  .module('working.with', [])
  .directive('workingWith', workingWith);
